module.exports = __webpack_public_path__ + "img/12.03bf9466.png";